export default __webpack_public_path__ + "static/media/cake_pinkchoco.99a6e3a2.jpg";